

const LOAD_ITEM_PROVIDERS = 'LOAD_ITEM_PROVIDERS';


const itemProvider = {
    providers:[]
};

export const selectProviders = state => state.itemProvider.providers;

export default function itemProviderReducer(state = itemProvider, { type, payload }) {

    switch (type) {

        case LOAD_ITEM_PROVIDERS:
            let newState = { ...state, ...payload }
            return newState;
        default:
            return state;
    }
}



export const loadItmeProviders = providers => ({
    type: LOAD_ITEM_PROVIDERS,
    payload: { providers: providers }
});
